import { render } from "./MultiCarousel.vue?vue&type=template&id=e28e5bf8"
import script from "./MultiCarousel.vue?vue&type=script&lang=js"
export * from "./MultiCarousel.vue?vue&type=script&lang=js"

import "./MultiCarousel.vue?vue&type=style&index=0&id=e28e5bf8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__